const ClearIcon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="14" height="14" viewBox="0 0 14 14"
		fill="none" stroke="currentColor"
		{...props}
	>
		<path d="M1 2H11M1 5H12M1 8H5" strokeWidth="2" />
		<path d="M7 8L12 13M12 8L7 13" strokeWidth="2" />
	</svg>
)

export default ClearIcon